<div
  #panel
  popover="auto"
  role="dialog"
  class="so-panel {{ panelClass() }}"
  [attr.id]="panelId()"
  [attr.aria-label]="titre()"
  [style.--so-largeur.px]="largeur()"
  [cdkTrapFocus]="ouvertReel()"
  (beforetoggle)="onBeforeToggle($event)"
  (toggle)="onToggle($event)"
  (click)="onPanelClick($event)"
>
  <header class="so-head">
    <div class="so-head-texte">
      <div class="so-titre-ligne">
        <h2 class="so-titre">{{ titre() }}</h2>
        <ng-content select="[slideOverTitleExtra]" />
      </div>
      @if (sousTitre(); as s) {
        <p class="so-sous num">{{ s }}</p>
      }
    </div>
    <button type="button" class="so-close" [attr.aria-label]="libelleFermer()" (click)="hide()">
      <svg lucideIcon="x" class="so-close-icon" aria-hidden="true"></svg>
    </button>
  </header>

  <ng-content select="[slideOverActions]" />

  <div class="so-body" [class.so-body--nu]="corpsNu()">
    <ng-content />
  </div>

  <ng-content select="[slideOverFooter]" />
</div>
